/* istanbul ignore file */
// @todo tymofiih@wix.com research enzyme render issue

import React from 'react';
import {Button, ButtonPriority, HoverStyles} from 'wix-ui-tpa/cssVars';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {
  IProvidedTranslationProps,
  withTranslations,
} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import BackInStockButtonStyles from './BackInStockButton.scss';
import productPageButtonsContainerStyles from '../ProductPageButtonsContainer.scss';
import {classes as addToCartButtonClasses} from '../AddToCartButton/AddToCartButton.st.css';
import {classes as buyNowButtonClasses} from '../BuyNowButton/BuyNowButton.st.css';
import classNames from 'classnames';

interface BackInStockButtonInterface extends ProvidedGlobalProps, IProvidedTranslationProps {
  className?: string;
}

interface BackInStockButtonState {
  showError: boolean;
}

export enum DataHook {
  Root = 'BackInStockButton.Root',
}

class BackInStockButtonComponent extends React.Component<BackInStockButtonInterface, BackInStockButtonState> {
  private createNotification() {
    this.props.globals.handleNotifyWhenBackInStock();
  }

  private getClasses() {
    const {shouldShowWishlistButton, shouldShowAddToCartButton, shouldShowBuyNowButton} = this.props.globals;
    return classNames({
      [addToCartButtonClasses.addToCartButton]: shouldShowAddToCartButton,
      [buyNowButtonClasses.buyNowButton]: !shouldShowAddToCartButton && shouldShowBuyNowButton,
      [productPageButtonsContainerStyles.primaryButton]: shouldShowWishlistButton,
      [this.props.className]: true,
      [BackInStockButtonStyles.fullWidth]: !shouldShowWishlistButton,
      [BackInStockButtonStyles.backInStockButton]: true,
    });
  }

  public render() {
    return (
      <Button
        data-hook={DataHook.Root}
        onClick={() => {
          this.createNotification();
        }}
        className={this.getClasses()}
        hoverStyle={this.props.globals.experiments.addToCartButtonColorContrast ? HoverStyles.underline : undefined}
        priority={this.props.globals.experiments.addToCartButtonColorContrast ? ButtonPriority.primary : undefined}>
        {this.props.t('productPage.backInStock.notifyWhenAvailable.button')}
      </Button>
    );
  }
}

export const BackInStockButton = withGlobalProps(withTranslations('globals.texts')(BackInStockButtonComponent));
